import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {useFieldArray, useForm} from 'react-hook-form';
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import {ButtonGroup, Chip, Divider} from "@mui/material";
import {saveInventoryEventGuests} from "../../common/api/InventoryApi";
import Button from "@mui/material/Button";
import ListCustomersResults from "../../client/ListCustomersResults";
import Grid from "@mui/material/Grid";
import {getCookie, setCookie} from "../../common/appCookie";
import {getCustomerFamily} from "../../common/api/WebApi";
import Checkbox from "@mui/material/Checkbox";
import {formatAge} from "../../common/Utils";

export default function AddGuestsModal({inventory, handleClose, handleSave, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);

  const [saving, setSaving] = useState(false);

  const handleModalClose = () => {
    handleClose();
  };

  useEffect(() => {
    setSaving(false);
  }, [show]);

  const filterGuests = (guests) => {
    let _guests = [];
    if (!guests) {
      return _guests;
    }
    for (let j in guests) {
      if (!guests[j]?.firstName || !guests[j].lastName) {
        continue;
      }
      _guests.push(guests[j])
    }
    return _guests;
  }

  const handleFormSave = async (data) => {
    setSaving(true);
    const req = {
      eventGuests: filterGuests(data.guests),
      eventGuid: inventory.guid,
      customers: customers
    }

    await saveInventoryEventGuests(req).then(resp => {
      handleSave(data);
      setSaving(false);
    });
  };


  const guest = {
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  }

  const addGuest = () => {
    append({...guest})
  }

  const {register, control, handleSubmit, reset, trigger, setError} = useForm({
    // defaultValues: {}; you can populate the fields by this attribute
  });

  const {fields, append, remove} = useFieldArray({
    control,
    name: "guests"
  });

  useEffect(() => {
    addGuest();
  }, []);

  const [customers, setCustomers] = useState([]);

  const [customer, setCustomer] = useState(null);

  const [showCustomer, setShowCustomer] = useState(false);

  const getCustomer = (customer) => {
    getCustomerFamily(customer.guid).then((resp) => {
      setCustomer(resp);
      setShowCustomer(true);
    })
  }

  const isChecked = (customer) => {
    return customers?.filter(item => item.id === customer.id)?.length > 0;
  }

  const addCustomer = (customer) => {
    let _customer = {
      id: customer.id,
      firstName: customer.firstName,
      lastName: customer.lastName,
      phone: customer.primaryPhone,
      email: customer.email
    }

    setCustomers((prevItems) => {
      const exists = prevItems.some(item => item.id === _customer.id);
      if (exists) {
        return prevItems;
      }
      return [...prevItems, _customer];
    });
  }

  const [tabActive, setTabActive] = useState(getCookie('ADD_GUESTS_TAB') || 'guest')

  useEffect(() => {
    setCookie('ADD_GUESTS_TAB', tabActive);
  }, [tabActive]);

  const sortAttendeesFunction = (a, b) => {
    const getRank = (person) => {
      if (person.primary) return 1;
      if (person.adult && !person.dob) return 2;
      if (person.adult) return 3;
      return 4;
    };

    const rankDiff = getRank(a) - getRank(b);
    if (rankDiff !== 0) return rankDiff;

    if (!a.adult && !b.adult) {
      let dateA = a.dob ? new Date(a.dob) : new Date();
      let dateB = b.dob ? new Date(b.dob) : new Date();
      return dateA.getTime() - dateB.getTime();
    }

    return 0;
  };

  return (
    <>
      <Modal onHide={handleClose} size={'xl'} show={show && !showCustomer}>
        <form onSubmit={handleSubmit(handleFormSave)} id={'brandForm'}>
          <Modal.Header closeButton>
            <Modal.Title>Add Guests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} className={'mb-4'}>
                <ButtonGroup className={'mb-2'}
                             variant="outlined"
                             size="small"
                             aria-label="Event Reservations">

                  <Button
                    size="small"
                    key={'guest'}
                    style={{
                      color: tabActive === 'guest' ? '#fff' : '#111',
                      background: tabActive === 'guest' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setTabActive('guest')
                    }}>
                    Create
                  </Button>

                  <Button
                    size="small"
                    key={'search'}
                    style={{
                      color: tabActive === 'search' ? '#fff' : '#111',
                      background: tabActive === 'search' ? '#111' : '#fff',
                      borderColor: '#111'
                    }}
                    onClick={(e) => {
                      setTabActive('search')
                    }}>
                    Search
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>

            {tabActive === 'search' && <>
              <Grid container>
                <Grid item xs={12}>
                  {customers?.length > 0 && <div className={"mb-2"}>
                    {customers?.map((c, idx) => {
                      return (<span key={idx}>
                       <Chip
                         label={<>{c.firstName + ' ' + c.lastName}</>}
                         variant="outlined"
                         onDelete={(e) => {
                           setCustomers(prev =>
                             prev.filter(customer => customer.id !== c.id)
                           );
                         }}
                       />&nbsp;
                      </span>)
                    })
                    }
                  </div>}
                </Grid>
                <Grid item xs={12}>
                  <Row>
                    <Col className={'col col-main'} xs={12}>
                      <Container>
                        <Row>
                          <Col className={'col'} sm={12} xs={12}>
                            <ListCustomersResults
                              actionLabel={'Add'}
                              embedded={true}
                              action={(customer) => {
                                getCustomer(customer);
                              }}
                            />
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </Grid>
              </Grid>
            </>
            }

            {tabActive === 'guest' && <>
              {fields.map((item, index) => (
                <Row key={item.id}>
                  <Col sm={12}>
                    <Row>
                      <Col sm={5}>
                        <MDInput
                          variant="outlined" type="text"
                          autoComplete="off" required
                          InputLabelProps={{shrink: true}}
                          {...register(`guests.${index}.firstName`)}
                          autoComplete="off"
                          className="form-control" id="firstName"
                          label="First Name"
                          placeholder="Enter First Name"/>

                      </Col>
                      <Col sm={5}>
                        <MDInput
                          variant="outlined" type="text"
                          autoComplete="off" required
                          InputLabelProps={{shrink: true}}
                          {...register(`guests.${index}.lastName`)}
                          autoComplete="off"
                          className="form-control" id="lastName"
                          label="Last Name"
                          placeholder="Enter Last Name"/>
                      </Col>
                      <Col sm={2}>
                        <label>Child</label>
                        <Checkbox
                          {...register(`guests.${index}.child`)}
                        />
                      </Col>
                    </Row>
                    <Row className={'mt-4'}>
                      <Col sm={5}>
                        <MDInput
                          variant="outlined" type="text"
                          autoComplete="off"
                          InputLabelProps={{shrink: true}}
                          {...register(`guests.${index}.phone`)}
                          autoComplete="off"
                          className="form-control" id="phone"
                          label="Phone"
                          placeholder="Enter Phone"/>

                      </Col>
                      <Col sm={5}>
                        <MDInput
                          variant="outlined" type="text"
                          autoComplete="off"
                          InputLabelProps={{shrink: true}}
                          {...register(`guests.${index}.email`)}
                          autoComplete="off"
                          className="form-control" id="email"
                          label="Email"
                          placeholder="Enter Email"/>

                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    {index > 0 && <MDButton
                      className={'pull-right mt-2'}
                      color="primary" size={"small"}
                      type="button" onClick={() => remove(index)}>Remove</MDButton>
                    }
                  </Col>
                  <Divider/>
                </Row>
              ))}
              <MDButton
                className={'pull-right mt-2'}
                color="primary" size={"small"}
                type="button" onClick={() => addGuest()}>Add Guest</MDButton>
            </>}

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>


      <Modal onHide={() => {
        setShowCustomer(false);
        setCustomer(null);
      }} size={'xl'} show={customer && showCustomer}>
        <form onSubmit={handleSubmit(handleFormSave)} id={'customerForm'}>
          <Modal.Header closeButton>
            <Modal.Title>Add Guests</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} className={'mb-4'}>

                {customer && <>
                  <Grid item sm={4} xs={12}>
                    <label>
                      <Checkbox
                        checked={isChecked(customer)}
                        onChange={() => {
                          addCustomer(customer);
                        }}
                        label={customer?.firstName + ' ' + customer?.lastName}
                      />
                      <span>{customer?.firstName} {customer?.lastName}</span>
                    </label>
                  </Grid>
                </>}

                {customer?.familyMembers?.sort(sortAttendeesFunction)?.map((m, index) => {
                  return (
                    <Grid item sm={4} xs={12}>
                      <label>
                        <Checkbox
                          checked={isChecked(m)}
                          onChange={() => {
                            addCustomer(m);
                          }}
                          label={m.firstName + ' ' + m.lastName}
                        />
                        <span>{m.firstName} {m.lastName}&nbsp;
                          {m?.familyMemberType === 1 && m?.dob && <>
                            ({formatAge(m)})
                          </>}
                                        </span>
                      </label>
                    </Grid>
                  )
                })}
              </Col>
            </Row>

          </Modal.Body>
          <Modal.Footer>
            <MDButton type="submit" color="info" disabled={formInvalid || saving}>
              {saving ? 'Saving...' : 'Save'}
            </MDButton>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}